// src/observer/AppObserver.jsx
import React, { useState } from "react";
import ObserverVote from "./ObserverVote";
import { getFirestore, collection, addDoc, serverTimestamp } from "firebase/firestore";

const OBSERVER_PASSWORD = "observer2025"; // değiştirilebilir

export default function AppObserver() {
  const [authed, setAuthed] = useState(false);
  const [pwd, setPwd] = useState("");
  const [err, setErr] = useState("");
  const db = getFirestore();

  const handleLogin = (e) => {
    e.preventDefault();
    if (pwd.trim() === OBSERVER_PASSWORD) {
      setAuthed(true);
      setErr("");
    } else {
      setErr("Wrong password");
    }
  };

  const vote = async (team, letter) => {
    try {
      await addDoc(collection(db, "observerVotes"), {
        team,             // "A" | "B"
        vote: letter,     // "D" | "I" | "S" | "C"
        timestamp: serverTimestamp(),
      });
      navigator.vibrate?.(20);
    } catch (_e) {}
  };

  if (!authed) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 16,
        }}
      >
        <form
          onSubmit={handleLogin}
          style={{
            width: "100%",
            maxWidth: 360,
            display: "flex",
            flexDirection: "column",
            gap: 12,
          }}
        >
          <h2 style={{ textAlign: "center" }}>Observer Login</h2>

          <input
            type="password"
            placeholder="Password"
            value={pwd}
            onChange={(e) => {
              setPwd(e.target.value);
              setErr("");
            }}
            style={{
              padding: 12,
              fontSize: 18,
              borderRadius: 8,
              border: "1px solid #ccc",
            }}
            autoFocus
          />

          {err && <div style={{ textAlign: "center", color: "#e53935" }}>{err}</div>}

          <button
            type="submit"
            style={{
              padding: "12px 16px",
              fontSize: 18,
              borderRadius: 10,
              border: "none",
              background: "#1E88E5",
              color: "white",
              cursor: "pointer",
            }}
          >
            Login
          </button>
        </form>
      </div>
    );
  }

  return (
    <ObserverVote
      onVoteA={(k) => vote("A", k)}
      onVoteB={(k) => vote("B", k)}
    />
  );
}
